// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"51e0cc31","551":"cdc243e9","842":"83506446"}[chunkId] + ".chunk.js";
};